import { ACTION } from './types';
import { api } from '../../../../configs/api';
import { ROUTE } from '../../../../routes';
import { ButtonTypeTokens, CalendarStateToken, InputStateToken, } from '@voltmoney/schema';
import SharedPropsService from '../../../../SharedPropsService';
import { getAppHeader, RegexConfig } from '../../../../configs/config';
import moment from 'moment';
import { isFromAndroidWebview, isFromTDLPlatform, nextStepId } from '../../../../configs/utils';
let pan = '';
let dob = '';
let counter = 0;
let isVerified = false;
export const verifyPan = async (action, _datastore, { network, asyncStorage, setDatastore, navigate, handleError, instrumentTrack, ...props }) => {
    instrumentTrack("VERIFY_PAN_BUTTON_CLICKED");
    await setDatastore(action.routeId, 'continue', {
        label: '',
        type: ButtonTypeTokens.LargeOutline,
        loading: true,
    });
    await network
        .post(api.panVerify, {
        applicationId: `${action.payload.applicationId}`,
        panNumber: `${pan}`,
        dob: dob,
    }, { headers: await getAppHeader() })
        .then(async (response) => {
        await setDatastore(action.routeId, 'continue', {
            label: 'Continue',
            type: ButtonTypeTokens.LargeFilled,
            loading: false,
        });
        if (response?.data.stepResponseObject?.fullName) {
            response.data.stepResponseObject.panNumber = pan;
            await setDatastore(action.routeId, 'input', {
                state: InputStateToken.SUCCESS,
            });
            const currentStepId = await response?.data.updatedApplicationObj
                .currentStepId;
            (await SharedPropsService.getUser()).linkedApplications[0].currentStepId = currentStepId;
            const userContextResponse = await network.post(api.userContext, {
                onboardingPartnerCode: await SharedPropsService.getPartnerRefCode(),
            }, { headers: await getAppHeader() });
            const user = userContextResponse.data;
            await SharedPropsService.setUser(user);
            // action?.payload?.setIsUserLoggedIn(user)
            // const user = await SharedPropsService.getUser();
            // await SharedPropsService.setUser(user);
            action?.payload?.setIsUserLoggedIn(user);
            await navigate(ROUTE.PAN_CONFIRM_NAME, {
                name: response?.data.stepResponseObject?.fullName,
                panNumber: response?.data.stepResponseObject?.panNumber,
                currentStepId: currentStepId,
            });
        }
    })
        .catch(async (error) => {
        await setDatastore(action.routeId, 'continue', {
            label: 'Continue',
            type: ButtonTypeTokens.LargeOutline,
            loading: false,
        });
    });
};
//returns whether validation is successful or not
export const ValidateForm = async (action, _datastore, { ...props }) => {
    let isDobComplete = false;
    //1. Store the action value, 2. Validate individual and take action, 3. Take action on form
    switch (action.payload.widgetId) {
        case 'input': {
            pan = action.payload.value;
            break;
        }
        case 'calendarPicker': {
            if (action.payload.value && action.payload.value.length == 10) {
                isDobComplete = true;
            }
            dob = `${moment(action.payload.value, 'DD-MM-yyyy').valueOf()}`;
            break;
        }
    }
    const currentDate = Date.now();
    const minDate = currentDate - 100 * 31557600000;
    const maxDate = currentDate - 18 * 31557600000;
    const panRegex = new RegExp(RegexConfig.PAN);
    const isDobValid = parseInt(dob) >= minDate && parseInt(dob) <= maxDate;
    const isPanValid = panRegex.test(pan);
    if (isDobValid) {
        const dobInddMMyyyy = moment.unix(Number(dob) / 1000).format('DD-MM-yyyy');
        await SharedPropsService.setUserDob(dobInddMMyyyy);
        await props.setDatastore(action.routeId, 'calendarPicker', {
            state: CalendarStateToken.DEFAULT,
        });
    }
    else if (isDobComplete) {
        //If dob is not valid but is complete in terms of format dd-MM-yyyy then throw error
        await props.setDatastore(action.routeId, 'calendarPicker', {
            state: CalendarStateToken.ERROR,
        });
    }
    const isValid = isDobValid && isPanValid;
    if (!isPanValid && pan.length == 10) {
        await props.setDatastore(action.routeId, 'input', {
            state: InputStateToken.ERROR,
            caption: { error: "Please enter a valid PAN number" },
        });
    }
    else if (pan.length != 10) {
        await props.setDatastore(action.routeId, 'input', {
            state: InputStateToken.DEFAULT,
            caption: { error: "" },
        });
    }
    else {
        await props.setDatastore(action.routeId, 'input', {
            state: InputStateToken.SUCCESS,
            caption: { error: "" },
        });
    }
    SharedPropsService.setPanValidated(isValid);
    isVerified = isValid;
    await toggleCTA({
        type: ACTION.ENABLE_CONTINUE,
        routeId: ROUTE.KYC_PAN_VERIFICATION,
        payload: {
            value: isValid,
            targetWidgetId: 'continue',
        },
    }, {}, props);
};
export const toggleCTA = async (action, _datastore, { setDatastore }) => {
    await setDatastore(action.routeId, action.payload.targetWidgetId, {
        type: action.payload.value && pan && dob
            ? ButtonTypeTokens.LargeFilled
            : ButtonTypeTokens.LargeOutline,
    });
};
export const goBack = async (action, _datastore, { navigateWithClear, navigate }) => {
    if (await SharedPropsService.showHome()) {
        const reFetch = false;
        await navigate(ROUTE.BORROWER_LANDING_SCREEN, { reFetch });
    }
    else {
        if (isFromAndroidWebview() && isFromTDLPlatform()) {
            window.open("closeActivity", "_parent");
        }
        window.parent.postMessage("Exit callback", "*");
        // @ts-ignore
        window?.webkit?.messageHandlers?.voltMessageHandler?.postMessage("closeActivity");
    }
};
export const needHelp = async (action, _datastore, { navigate, ...props }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const ValidatePan = async (action, _datastore, { setDatastore }) => {
    const pan = action?.payload?.value;
    const panRegex = new RegExp(RegexConfig.PAN);
    const isPanValid = panRegex.test(pan);
    if (!isPanValid && pan.length == 10) {
        await setDatastore(action.routeId, 'kycPanVerification', {
            state: InputStateToken.ERROR,
            caption: { error: "Please enter a valid PAN number" },
        });
    }
    else if (pan.length !== 10) {
        await setDatastore(action.routeId, 'kycPanVerification', {
            state: InputStateToken.DEFAULT,
            caption: { error: "" },
        });
    }
    else {
        await setDatastore(action.routeId, 'kycPanVerification', {
            state: InputStateToken.SUCCESS,
            caption: { error: "" },
        });
    }
};
export const ValidateDob = async (action, _datastore, { ...props }) => {
    let isDobComplete = false;
    if (action.payload.value && action.payload.value.length == 10) {
        isDobComplete = true;
    }
    dob = `${moment(action.payload.value, 'DD-MM-yyyy').valueOf()}`;
    const currentDate = Date.now();
    const minDate = currentDate - 100 * 31557600000;
    const maxDate = currentDate - 18 * 31557600000;
    const isDobValid = parseInt(dob) >= minDate && parseInt(dob) <= maxDate;
    if (isDobComplete) {
        if (isDobValid) {
            const dobInddMMyyyy = moment.unix(Number(dob) / 1000).format('DD-MM-yyyy');
            await SharedPropsService.setUserDob(dobInddMMyyyy);
            await props.setDatastore(action.routeId, 'kycPanVerification', {
                dobState: CalendarStateToken.SUCCESS,
            });
        }
        else {
            await props.setDatastore(action.routeId, 'kycPanVerification', {
                dobState: CalendarStateToken.ERROR,
            });
        }
    }
    else {
        await props.setDatastore(action.routeId, 'kycPanVerification', {
            dobState: CalendarStateToken.DEFAULT,
        });
    }
};
export const Continue = async (action, _datastore, { network, asyncStorage, setDatastore, navigate, handleError, showPopup, instrumentTrack, ...props }) => {
    instrumentTrack("VERIFY_PAN_BUTTON_CLICKED");
    await setDatastore(action.routeId, 'kycPanVerification', {
        dobState: CalendarStateToken.DEFAULT,
        state: InputStateToken.DEFAULT,
        showKycModal: false,
        showErrorModal: false,
        counter: counter++,
        modalHeight: 0
    });
    const response = await network.post(api.panVerify, {
        applicationId: `${action?.payload?.applicationId}`,
        panNumber: `${action?.payload?.value}`,
        dob: dob,
    }, { headers: await getAppHeader(), handleFromMF: true });
    if (response?.data?.stepResponseObject?.fullName) {
        response.data.stepResponseObject.panNumber = action?.payload?.value;
        const currentStepId = await response?.data.updatedApplicationObj
            .currentStepId;
        (await SharedPropsService.getUser()).linkedApplications[0].currentStepId = currentStepId;
        await setDatastore(action.routeId, 'kycPanVerification', {
            state: InputStateToken.SUCCESS,
            dobState: CalendarStateToken.SUCCESS,
            userName: response?.data?.stepResponseObject?.fullName,
            showKycModal: true,
            showErrorModal: false,
            counter: counter++,
            modalHeight: 392
        });
        const userContextResponse = await network.post(api.userContext, {
            onboardingPartnerCode: await SharedPropsService.getPartnerRefCode(),
        }, { headers: await getAppHeader() });
        const user = userContextResponse.data;
        await SharedPropsService.setUser(user);
        // action?.payload?.setIsUserLoggedIn(user)
    }
    else {
        if (response?.response?.status === 400) {
            await setDatastore(action.routeId, 'kycPanVerification', {
                showErrorModal: true,
                errorMessage: response?.response?.data?.message,
                counter: counter++,
                modalHeight: 236
            });
        }
        else {
            await setDatastore(action.routeId, 'kycPanVerification', {
                showErrorModal: true,
                errorMessage: "Something went wrong",
                counter: counter++,
                modalHeight: 210
            });
        }
    }
};
export const confirmPan = async (action, _datastore, { instrumentTrack, asyncStorage, goBack, setDatastore, navigate, navigateWithClear, ...props }) => {
    instrumentTrack("CONFIRM_PAN_BUTTON_CLICKED");
    const user = await SharedPropsService.getUser();
    user.linkedBorrowerAccounts[0].accountHolderPAN = action.payload.panNumber;
    await SharedPropsService.setUser(user);
    const currentStepId = user?.linkedApplications[0]?.currentStepId;
    const routeObj = await nextStepId(currentStepId);
    await navigateWithClear(routeObj.routeId, routeObj.params);
};
export const closePanModal = async (action, _datastore, { setDatastore, network }) => {
    await setDatastore(action.routeId, 'kycPanVerification', {
        showErrorModal: false,
        showKycModal: false,
        modalHeight: 0
    });
    const user = await SharedPropsService.getUser();
    const applicationId = user.linkedApplications[0].applicationId;
    await network.post(`${api.panReset}${applicationId}`, {}, { headers: await getAppHeader() });
};
export const fetchExistingPan = async (action, _datastore, { setDatastore, network }) => {
    const user = await SharedPropsService.getUser();
    const accountId = user.linkedBorrowerAccounts[0].accountId;
    await setDatastore(action.routeId, 'kycPanVerification', {
        fetchedData: false,
    });
    const response = await network
        .get(`${api.userProfile}${accountId}`, {
        headers: await getAppHeader(),
    })
        .then(response => response.data)
        .catch(error => console.log('error', error));
    const prefilledPanNumber = response.panNumber;
    await setDatastore(action.routeId, 'kycPanVerification', {
        prefilledPanNumber: prefilledPanNumber,
        fetchedData: true,
    });
};
export const editDetailsAction = async (action, _datastore, { navigate, network }) => {
    const user = await SharedPropsService.getUser();
    const applicationId = user.linkedApplications[0].applicationId;
    await network.post(`${api.panReset}${applicationId}`, {}, { headers: await getAppHeader() });
};
export const closeModal = async (action, _datastore, { setDatastore, network }) => {
    await setDatastore(action.routeId, 'kycPanVerification', {
        showErrorModal: false,
        showKycModal: false,
        modalHeight: 0
    });
};
